import React, { useState } from 'react'
import { Form, Row, Col, Select } from 'antd'
import { createPlaywrightForm } from '../../createPlaywrightForm'
const FormFilter = ({form,rules}) => {
    const { getFieldDecorator } = form
    const [keys,setKeys] = useState(Object.keys(rules))
    return(
        <>
            <Form>
                <Row>
                    <Col xs={{span: 6}}>
                        <Form.Item
                            label="Elemento"
                        >
                            {getFieldDecorator("element")(
                                <Select
                                    optionLabelProp="label"
                                    placeholder="Tipo de pregunta"
                                >
                                {keys.map((item,index) => (
                                    <Select.Option key={index} value={rules[item]} label={`${item}` || ""}>{item}</Select.Option>
                                ))}
                                </Select>
                            )}                   
                        </Form.Item>
                    </Col>
                    <Col xs={{span: 6, offset: 2}}>
                        <Form.Item
                            label="Elemento"
                        >
                            {getFieldDecorator("element")(
                                <Select
                                    optionLabelProp="label"
                                    placeholder="Tipo de pregunta"
                                >
                                {keys.map((item,index) => (
                                    <Select.Option key={index} value={rules[item]} label={`${item}` || ""}>{item}</Select.Option>
                                ))}
                                </Select>
                            )}                   
                        </Form.Item>    
                    </Col>
                    <Col xs={{span: 6, offset: 2}}>
                        <Form.Item
                            label="Elemento"
                        >
                            {getFieldDecorator("element")(
                                <Select
                                    optionLabelProp="label"
                                    placeholder="Tipo de pregunta"
                                >
                                {keys.map((item,index) => (
                                    <Select.Option key={index} value={rules[item]} label={`${item}` || ""}>{item}</Select.Option>
                                ))}
                                </Select>
                            )}                   
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </>
    )
}

const createForm = typeof Form.create === 'function' ? Form.create : createPlaywrightForm
export const FilterForm = createForm({name: "filter_form" })(FormFilter)
